module.exports = __webpack_public_path__ + "static/media/11NEPAD12.6f8c7d60.jpg";